import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import ReactSelectMaterialUi from 'react-select-material-ui';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Modal from '@material-ui/core/Modal';
import {
  FormLabel,
  Link,
  ListItem,
  Select,
  Tab,
  Tabs
} from '@material-ui/core';
import classNames from 'classnames';
import RequiredButton from '../../components/atoms/RequiredButton';
import AnyButton from '../../components/atoms/AnyButton';
import ValidationText from '../../components/atoms/ValidationText';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import FileUpload from '../../components/molecules/FileUpload';
import { languages, languageType } from '../../constants/Language';
import {
  getGroupDetail,
  editGroup,
  countGroupEmail,
  addGroupImage
} from '../../actions/Groups';
import { getZipCode } from '../../actions/Shop';
import { sendLogin, resizeImage, uploadFile } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';
import { getOptionCities } from '../../actions/Cities';
import TabPanelDetail from '../../components/atoms/TabPanelDetail';
import GroupEditConfirmGroup from './GroupEditConfirmGroup';

const styles = {
  root: {
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    backgroundColor: '#fff',
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4
  },
  pageTitle: {
    margin: '40px',
    textAlign: 'left',
    backgroundColor: '#fff',
    fontWeight: 'bold'
  },
  titleDetail: {
    fontSize: 20,
    fontWeight: 'bold',
    margin: 40,
    marginBottom: 20
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  editTable: {
    width: '100%'
  },
  tableCell90: {
    width: '90%'
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  depositManageDiv: {
    paddingTop: '1.5rem'
  },
  discription: {
    fontSize: '0.875rem'
  },
  textField: {
    padding: 0
  },
  button: {
    margin: '5px auto'
  },
  tabpanelHeader: {
    padding: '0 40px',
    borderBottom: '2px solid #D8EBFF',
    minHeight: 'unset'
  },
  btnTabpanel: {
    padding: '5px 10px',
    backgroundColor: '#F7F7F7',
    borderRadius: '3px 3px 0 0',
    fontSize: 14,
    fontWeight: 600,
    color: '#777777',
    height: 'auto',
    minHeight: 'unset',
    borderTop: '5px solid #ffffff',
    width: 165,

    '&:first-child': {
      marginRight: 2
    },
    '&:last-child': {
      marginLeft: 2
    }
  },
  tabSelected: {
    backgroundColor: '#D8EBFF',
    fontWeight: 'bold',
    color: '#000000 !important',
    borderTopColor: '#D8EBFF'
  },
  panelDetail: {
    // padding: '15px 30px',
    display: 'flex'
  },
  labelCell: {
    // padding: 0,
    verticalAlign: 'top',
    maxWidth: 90,
    width: 90
  },
  descriptionText: {
    fontSize: 12,
    whiteSpace: 'pre-line',
    fontWeight: '500'
  },
  noPaddingTop: {
    paddingTop: 0
  },
  fontSize12: {
    fontSize: 12
  },
  buttonContainer: {
    marginBottom: 15,
    marginLeft: 15
  },
  modal: {
    maxWidth: 978,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  selectContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  select: {
    width: '300px'
  },
  detailDescription: {
    display: 'block',
    marginTop: 10
  },
  disableInput: {
    backgroundColor: '#d9d9d9'
  },
  link: {
    textDecoration: 'underline'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      cities: state.cities.listCities,
      prefectures: state.commons.prefectures
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGroupDetail,
          editGroup,
          addGroupImage,
          countGroupEmail,
          getAccounts,
          getOptionCities,
          getZipCode
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('tab', 'setTab', 0),
  withState('openEditProgress', 'updateOpenEditProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isEditSuccess', 'updateIsEditSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('groupId', 'setGroupId', ''),
  withState('groupName', 'setGroupName', ''),
  withState('countryCode', 'setCountryCode', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('prefectureCode', 'setPrefectureCode', 0),
  withState('cityIdError', 'setCityIdError', ''),
  withState('city', 'setCity', ''),
  withState('cityId', 'setCityId', ''),
  // withState('cityName', 'setCityName', ''),
  // withState('cityNameError', 'setCityNameError', ''),
  withState('address', 'setAddress', ''),
  withState('building', 'setBuilding', ''),
  withState('phone', 'setPhone', ''),
  withState('fax', 'setFax', ''),
  withState('groupContactEmail', 'setGroupContactEmail', ''),
  withState('groupContactName', 'setGroupContactName', ''),
  withState('department', 'setDepartment', ''),
  withState('directPhone', 'setDirectPhone', ''),
  withState('groupType', 'setGroupType', 'CHAIN_SHOP'),
  withState('groupTypeStr', 'setGroupTypeStr', 'チェーン店'),
  withState('email', 'setEmail', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('groupNameError', 'setGroupNameError', ''),
  withState('zipCodeError', 'setZipCodeError', ''),
  withState('cityError', 'setCityError', ''),
  withState('addressError', 'setAddressError', ''),
  withState('groupContactNameError', 'setGroupContactNameError', ''),
  withState('departmentError', 'setDepartmentError', ''),
  withState('directPhoneError', 'setDirectPhoneError', ''),
  withState('phoneError', 'setPhoneError', ''),
  withState('emailError', 'setEmailError', ''),
  withState('depositManage', 'setDepositManage', 'NOT_MANAGE'),
  withState(
    'depositManageStr',
    'setDepositManageStr',
    'グループでは入金管理を登録しない'
  ),
  withState('bankName', 'setBankName', ''),
  withState('bankBranchName', 'setBankBranchName', ''),
  withState('bankAccountType', 'setBankAccountType', 'SAVINGS'),
  withState('bankAccountTypeStr', 'setBankAccountTypeStr', '普通預金'),
  withState('bankAccountNumber', 'setBankAccountNumber', ''),
  withState('bankAccountNumberError', 'setBankAccountNumberError', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('bankAccountHolderError', 'setBankAccountHolderError', ''),
  withState('stripeUseSwitchable', 'setStripeUseSwitchable', true),
  withState('images', 'setImages', null),
  withState('image1', 'setImage1', null),
  withState('previewImage1', 'setPreviewImage1', null),
  withState('image2', 'setImage2', null),
  withState('previewImage2', 'setPreviewImage2', null),
  withState('image3', 'setImage3', null),
  withState('previewImage3', 'setPreviewImage3', null),
  withState('image4', 'setImage4', null),
  withState('previewImage4', 'setPreviewImage4', null),
  withState('image5', 'setImage5', null),
  withState('previewImage5', 'setPreviewImage5', null),
  withState('description', 'setDescription', ''),
  withState('linkingShopMessage', 'setLinkingShopMessage', ''),
  withState('website', 'setWebsite', ''),
  withState('websiteError', 'setWebsiteError', ''),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withState('translateType', 'setTranslateType', 0),
  withState('multiLangData', 'setMultiLangData', {}),
  withState('cashAllowed', 'setCashAllowed', 0),
  withState('allowMenuPriceShashoku', 'setAllowMenuPriceShashoku', 0),
  withState('bankCode', 'setBankCode', ''),
  withState('bankCodeError', 'setBankCodeError', ''),
  withState('bankBranchCode', 'setBankBranchCode', ''),
  withState('bankBranchCodeError', 'setBankBranchCodeError', ''),
  withState('haveRegistrationId', 'setHaveRegistrationId', 0),
  withState('registrationId', 'setRegistrationId', 'T'),
  withState('registrationIdError', 'setRegistrationIdError', ''),

  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.getOptionCities();
      this.props.setGroupId(this.props.editInput.groupId);
      this.props.setGroupName(this.props.editInput.groupName);
      this.props.setCountryCode(this.props.editInput.countryCode);
      this.props.setZipCode(this.props.editInput.zipCode);
      this.props.setPrefectureCode(this.props.editInput.prefectureCode);
      this.props.setCity(this.props.editInput.city);
      this.props.setAddress(this.props.editInput.address);
      this.props.setBuilding(this.props.editInput.building);
      this.props.setPhone(this.props.editInput.phone);
      this.props.setFax(this.props.editInput.fax);
      this.props.setGroupContactEmail(this.props.editInput.groupContactEmail);
      this.props.setGroupContactName(this.props.editInput.groupContactName);
      this.props.setDepartment(this.props.editInput.department);
      this.props.setDirectPhone(this.props.editInput.directPhone);
      this.props.setGroupType(this.props.editInput.groupType);
      this.props.setGroupTypeStr(this.props.editInput.groupTypeStr);
      this.props.setDepositManage(this.props.editInput.depositManage);
      this.props.setDepositManageStr(this.props.editInput.depositManageStr);
      this.props.setBankName(this.props.editInput.bankAccount.bankName);
      this.props.setBankBranchName(
        this.props.editInput.bankAccount.bankBranchName
      );
      this.props.setBankAccountType(
        this.props.editInput.bankAccount.bankAccountType === null
          ? 'SAVINGS'
          : this.props.editInput.bankAccount.bankAccountType
      );
      this.props.setBankAccountTypeStr(
        this.props.editInput.bankAccount.bankAccountTypeStr === null
          ? '普通預金'
          : this.props.editInput.bankAccount.bankAccountTypeStr
      );
      this.props.setBankAccountNumber(
        this.props.editInput.bankAccount.bankAccountNumber
      );
      this.props.setBankAccountHolder(
        this.props.editInput.bankAccount.bankAccountHolder
      );
      this.props.setStripeUseSwitchable(
        this.props.editInput.stripeUseSwitchable
      );
      this.props.setEmail(this.props.editInput.email);
      this.props.setUpdatedAt(this.props.editInput.updatedAt);
      this.props.setLinkingShopMessage(this.props.editInput.linkingShopMessage);
      this.props.setDescription(this.props.editInput.description);
      this.props.setWebsite(this.props.editInput.website);
      this.props.setCashAllowed(
        (this.props.editInput.groupDetail &&
          this.props.editInput.groupDetail.cashAllowed) ||
          0
      );
      this.props.setAllowMenuPriceShashoku(
        this.props.editInput.groupDetail &&
          this.props.editInput.groupDetail.allowMenuPriceShashoku !== null &&
          this.props.editInput.groupDetail.allowMenuPriceShashoku !== undefined
          ? this.props.editInput.groupDetail.allowMenuPriceShashoku
          : 1
      );
      if (
        this.props.editInput.groupImages &&
        typeof this.props.editInput.groupImages[0] !== 'undefined'
      ) {
        this.props.setPreviewImage1(this.props.editInput.groupImages[0].image);
      }
      if (
        this.props.editInput.groupImages &&
        typeof this.props.editInput.groupImages[1] !== 'undefined'
      ) {
        this.props.setPreviewImage2(this.props.editInput.groupImages[1].image);
      }
      if (
        this.props.editInput.groupImages &&
        typeof this.props.editInput.groupImages[2] !== 'undefined'
      ) {
        this.props.setPreviewImage3(this.props.editInput.groupImages[2].image);
      }
      if (
        this.props.editInput.groupImages &&
        typeof this.props.editInput.groupImages[3] !== 'undefined'
      ) {
        this.props.setPreviewImage4(this.props.editInput.groupImages[3].image);
      }
      if (
        this.props.editInput.groupImages &&
        typeof this.props.editInput.groupImages[4] !== 'undefined'
      ) {
        this.props.setPreviewImage5(this.props.editInput.groupImages[4].image);
      }
      this.props.setBankCode(this.props.editInput.bankAccount.bankCode);
      this.props.setBankBranchCode(
        this.props.editInput.bankAccount.bankBranchCode
      );
      if (this.props.editInput.registrationId) {
        this.props.setHaveRegistrationId(1);
        this.props.setRegistrationId(this.props.editInput.registrationId);
      } else {
        this.props.setHaveRegistrationId(0);
        this.props.setRegistrationId('T');
      }

      let dataFirst = {};
      const origilData = {
        groupName: null,
        address: null,
        building: null,
        groupContactEmail: null,
        groupContactName: null,
        department: null,
        linkingShopMessage: null,
        description: null,
        countryCode: null,
        zipCode: null,
        prefectureCode: null,
        city: null,
        cityId: null,
        phone: null,
        fax: null,
        directPhone: null,
        groupType: null,
        email: null,
        depositManage: null,
        bankAccount: null,
        updatedAt: null,
        website: null,
        cashAllowed: null,
        allowMenuPriceShashoku: null
      };

      dataFirst = origilData;
      if (this.props.editInput.otherLanguages) {
        const str = JSON.stringify(this.props.editInput.otherLanguages);
        dataFirst.otherLanguages = JSON.parse(str);
      }
      languages.forEach(item => {
        if (item.value === languageType.ORIGIN) return;
        const translatedData = dataFirst.otherLanguages.find(
          el => el.language === item.value
        );
        if (!translatedData) {
          const other = {
            translateType: 0,
            language: item.value
          };
          dataFirst.otherLanguages.push(other);
        }
      });
      this.props.setMultiLangData(dataFirst);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    editInput,
    tab,
    setTab,
    setDisplayGroupName,
    prefectures,
    checkSession,
    groupId,
    groupName,
    setGroupName,
    countryCode,
    zipCode,
    setZipCode,
    prefectureCode,
    setPrefectureCode,
    cities,
    city,
    setCity,
    cityId,
    setCityId,
    // cityName,
    // setCityName,
    address,
    setAddress,
    building,
    setBuilding,
    phone,
    setPhone,
    fax,
    setFax,
    groupContactEmail,
    setGroupContactEmail,
    groupContactName,
    setGroupContactName,
    department,
    setDepartment,
    directPhone,
    setDirectPhone,
    groupType,
    setGroupType,
    groupTypeStr,
    setGroupTypeStr,
    email,
    setEmail,
    depositManage,
    setDepositManage,
    depositManageStr,
    setDepositManageStr,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    stripeUseSwitchable,
    groupNameError,
    setGroupNameError,
    zipCodeError,
    setZipCodeError,
    cityIdError,
    setCityIdError,
    addressError,
    setAddressError,
    groupContactNameError,
    setGroupContactNameError,
    departmentError,
    setDepartmentError,
    directPhoneError,
    setDirectPhoneError,
    phoneError,
    setPhoneError,
    emailError,
    setEmailError,
    bankAccountNumberError,
    setBankAccountNumberError,
    bankAccountHolderError,
    setBankAccountHolderError,
    updatedAt,
    updateOpenEditModal,
    openEditConfirm,
    updateOpenEditConfirm,
    openEditProgress,
    updateOpenEditProgress,
    loading,
    updateLoading,
    isEditSuccess,
    updateIsEditSuccess,
    resultMessage,
    setResultMessage,
    image1,
    setImage1,
    previewImage1,
    setPreviewImage1,
    image2,
    setImage2,
    previewImage2,
    setPreviewImage2,
    image3,
    setImage3,
    previewImage3,
    setPreviewImage3,
    image4,
    setImage4,
    previewImage4,
    setPreviewImage4,
    image5,
    setImage5,
    previewImage5,
    setPreviewImage5,
    description,
    setDescription,
    linkingShopMessage,
    setLinkingShopMessage,
    website,
    setWebsite,
    websiteError,
    setWebsiteError,
    onEditSuccess,
    isLanguage,
    setIsLanguage,
    multiLangData,
    setMultiLangData,
    translateType,
    setTranslateType,
    cashAllowed,
    // setCashAllowed,
    allowMenuPriceShashoku,
    setAllowMenuPriceShashoku,
    isFukuoka,
    bankCode,
    setBankCode,
    bankCodeError,
    setBankCodeError,
    listBank,
    bankBranchCode,
    setBankBranchCode,
    bankBranchCodeError,
    setBankBranchCodeError,
    listBankBranch,
    haveRegistrationId,
    setHaveRegistrationId,
    registrationId,
    setRegistrationId,
    registrationIdError,
    setRegistrationIdError
  }) => {
    const groupDisplayLimit =
      groupType === 'CAMPAIGN' ||
      groupType === 'OTHERS' ||
      groupType === 'GOCHI_KID';

    const handleChange = (event, newValue) => {
      setTab(newValue);
    };

    const otherData = {
      groupTypeStr,
      depositManageStr,
      bankName,
      bankBranchName,
      bankAccountTypeStr,
      bankAccountNumber,
      bankAccountHolder,
      previewImage1,
      previewImage2,
      previewImage3,
      previewImage4,
      previewImage5
    };

    const bankAccount = {
      bankName,
      bankBranchName,
      bankAccountType,
      bankAccountNumber,
      bankAccountHolder,
      bankCode,
      bankBranchCode
    };

    const getCurrentData = () => {
      const lang = isLanguage;
      let data = multiLangData;
      const origilParam = {
        groupName,
        address,
        building,
        groupContactEmail,
        groupContactName,
        department,
        description,
        linkingShopMessage,
        countryCode,
        zipCode,
        prefectureCode,
        city,
        cityId,
        phone,
        fax,
        directPhone,
        groupType,
        email,
        depositManage,
        bankAccount,
        updatedAt,
        website,
        groupDetail:
          groupType !== 'OTHERS' &&
          groupType !== 'CAMPAIGN' &&
          groupType !== 'GOCHI_KID'
            ? {
                groupDetailId: editInput.groupDetail.groupDetailId,
                cashAllowed,
                allowMenuPriceShashoku
              }
            : undefined,
        registrationId: haveRegistrationId ? registrationId : undefined
      };

      const otherParam = {
        translateType,
        language: lang,
        params: {
          groupName,
          groupContactName,
          department,
          description
        }
      };
      // origin
      if (lang === languageType.ORIGIN) {
        data = { ...data, ...origilParam };
      } else {
        // other languages
        for (let index = 0; index < data.otherLanguages.length; index += 1) {
          if (data.otherLanguages[index].language === lang) {
            data.otherLanguages[index] = otherParam;
          }
        }
      }
      const str = JSON.stringify(data);
      return JSON.parse(str);
    };

    const setLanguage = v => {
      const lang = isLanguage;
      const data = getCurrentData();
      if (
        (v !== languageType.ORIGIN && lang === languageType.ORIGIN) ||
        (v !== languageType.ORIGIN && lang !== languageType.ORIGIN)
      ) {
        // origin to other or other to other lang
        for (let k = 0; k < multiLangData.otherLanguages.length; k += 1) {
          if (multiLangData.otherLanguages[k].language === v) {
            setGroupName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.groupName
                ? multiLangData.otherLanguages[k].params.groupName
                : ''
            );
            setGroupContactName(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.groupContactName
                ? multiLangData.otherLanguages[k].params.groupContactName
                : ''
            );
            setDepartment(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.department
                ? multiLangData.otherLanguages[k].params.department
                : ''
            );
            setDescription(
              multiLangData.otherLanguages[k].params &&
                multiLangData.otherLanguages[k].params.description
                ? multiLangData.otherLanguages[k].params.description
                : ''
            );
            setTranslateType(
              multiLangData.otherLanguages[k].translateType
                ? multiLangData.otherLanguages[k].translateType
                : 0
            );
          }
        }
      } else if (v === languageType.ORIGIN) {
        setGroupName(multiLangData.groupName);
        setGroupContactName(multiLangData.groupContactName);
        setDepartment(multiLangData.department);
        setDescription(multiLangData.description);
      }
      setIsLanguage(v);
      setMultiLangData(data);
    };

    const errors = {
      groupNameError,
      zipCodeError,
      cityIdError,
      addressError,
      groupContactNameError,
      departmentError,
      directPhoneError,
      phoneError,
      emailError,
      bankAccountNumberError,
      bankAccountHolderError,
      websiteError,
      bankCodeError,
      bankBranchCodeError,
      registrationIdError
    };

    // const getZipCodeData = async zipcode => {
    //   await actions.getZipCode(zipcode).then(data => {
    //     setPrefectureCode(data.payload.prefectureCode);
    //     setCity(data.payload.city);
    //     setAddress(data.payload.address);
    //     setNewCityId(data.payload.city);
    //   });
    // };

    const checkCityName = () => {
      console.log('cityId', city);
      const chosenCityNameList = [];
      cities
        .filter(item => item.cityName && item.cityName === city)
        .forEach(item => {
          chosenCityNameList.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      if (chosenCityNameList.length > 0) {
        console.log('cityId', Number(chosenCityNameList[0].value));
        return Number(chosenCityNameList[0].value);
      }
      return Number(0);
    };

    useEffect(() => {
      setCityId(checkCityName());
    }, [city]);

    // const setNewCityId = newCity => {
    //   const chosenCityNameList = [];
    //   cities
    //     .filter(item => item.cityName && item.cityName === newCity)
    //     .forEach(item => {
    //       chosenCityNameList.push({
    //         label: item.cityName,
    //         value: String(item.cityId)
    //       });
    //     });
    //   if (chosenCityNameList.length > 0) {
    //     setCityId(Number(chosenCityNameList[0].value));
    //   }
    // };

    const validGroupName = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = groupName;
      if (value.trim() === '') {
        setGroupNameError('必須項目です。');
        return 1;
      }
      setGroupNameError('');
      setGroupName(value);
      return 0;
    };
    const validZipCode = () => {
      const value = zipCode;
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      // getZipCodeData(value);
      return 0;
    };
    const validZipCodeSubmit = () => {
      const value = zipCode;
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      return 0;
    };
    // const validCity = () => {
    //   const value = city;
    //   if (value === '') {
    //     setCityError('必須項目です。');
    //     return 1;
    //   }
    //   setCityError('');
    //   setCity(value);
    //   return 0;
    // };
    const validCityId = () => {
      const value = cityId;
      if (value === 0) {
        setCityIdError('必須項目です。');
        return 1;
      }
      setCityIdError('');
      // setCityId(value);
      return 0;
    };
    const setCityNameData = id => {
      cities.forEach(item => {
        if (id === item.cityId) {
          setCity(item.cityName);
        }
      });
    };
    const validAddress = () => {
      const value = address.trim();
      if (value.trim() === '') {
        setAddressError('必須項目です。');
        return 1;
      }
      setAddressError('');
      setAddress(value);
      return 0;
    };
    const validGroupContactName = () => {
      const value = groupContactName.trim();
      if (value === '') {
        setGroupContactNameError('必須項目です。');
        return 1;
      }
      setGroupContactNameError('');
      setGroupContactName(value);
      return 0;
    };
    const validDepartment = () => {
      if (isLanguage !== languageType.ORIGIN && translateType === 0) {
        return 0;
      }
      const value = department.trim();
      if (value === '') {
        setDepartmentError('必須項目です。');
        return 1;
      }
      setDepartmentError('');
      setDepartment(value);
      return 0;
    };
    const validDirectPhone = () => {
      const value = directPhone;
      if (value === '') {
        setDirectPhoneError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setDirectPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setDirectPhoneError('');
      setDirectPhone(value);
      return 0;
    };
    const validPhone = () => {
      const value = phone;
      if (value === '') {
        setPhoneError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setPhoneError('');
      setPhone(value);
      return 0;
    };
    const validEmail = () => {
      const value = email;
      if (value === '') {
        setEmailError('必須項目です。');
        return 1;
      }
      setEmailError('');
      setEmail(value);
      return 0;
    };
    const validEmailCount = emailData => {
      const value = email;
      if (
        emailData.payload.totalCount > 0 &&
        editInput.email !== emailData.payload.groups[0].email
      ) {
        setEmailError('メールアドレスが既に登録されています。');
        return 1;
      }
      setEmailError('');
      setEmail(value);
      return 0;
    };
    const validBankAccountNumber = () => {
      const value = bankAccountNumber;
      if (depositManage === 'NONSELF') {
        if (!value) {
          setBankAccountNumberError('必須項目です。');
          return 1;
        }
        if (!/^\d{7}$/.test(value)) {
          setBankAccountNumberError('半角数字のみで7桁で入力してください。');
          return 1;
        }
      }
      setBankAccountNumberError('');
      setBankAccountNumber(value);
      return 0;
    };
    const validBankAccountHolder = () => {
      const value = bankAccountHolder;
      if (depositManage === 'NONSELF') {
        if (!value) {
          setBankAccountHolderError('必須項目です。');
          return 1;
        }
        if (
          !/^[0-9a-zA-Z!-/:-@¥[-`{-~！-／：-＠［-｀｛-～、-〜”’・ー‐−―￥ァ-ヴ\x20\u3000]+$/.test(
            value
          )
        ) {
          setBankAccountHolderError('漢字/ひらがな以外で入力してください。');
          return 1;
        }
      }
      setBankAccountHolderError('');
      setBankAccountHolder(value);
      return 0;
    };
    const validWebsite = () => {
      const value = website;
      const pattern = /(http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
      if (value && !pattern.test(value)) {
        setWebsiteError('URLを入力してください');
        return 1;
      }
      setWebsiteError('');
      setWebsite(value);
      return 0;
    };

    const validRegistrationId = () => {
      const value = registrationId;
      if (isFukuoka || groupDisplayLimit) {
        return 0;
      }
      if (haveRegistrationId === 1) {
        const valueNumber = value.slice(1);
        if (!value || !valueNumber) {
          setRegistrationIdError('必須項目です。');
          return 1;
        }
        if (!/^\d+$/.test(valueNumber)) {
          setRegistrationIdError('半角数字のみ入力してください。');
          return 1;
        }
        if (valueNumber.length !== 13) {
          setRegistrationIdError('13桁の番号をご入力ください。');
          return 1;
        }
      }
      setRegistrationId(value);
      setRegistrationIdError('');
      return 0;
    };

    const getBankName = bankCodeValue => {
      let listBankName = [];
      listBankName = listBank.filter(bank => bank.bankCode === bankCodeValue);
      if (listBankName.length === 0) {
        setBankCodeError('データが正しくありません。');
        setBankName('');
        return false;
      }
      setBankName(listBankName[0].bankName);
      return true;
    };

    const getBankBranchName = bankBranchCodeValue => {
      let listBankBranchName = [];
      listBankBranchName = listBankBranch.filter(
        bankBranch => bankBranch.uniqueCode === bankCode + bankBranchCodeValue
      );
      if (listBankBranchName.length === 0) {
        setBankBranchCodeError('データが正しくありません。');
        setBankBranchName('');
        return false;
      }
      setBankBranchName(listBankBranchName[0].bankBranchName);
      return true;
    };

    const validBankCode = () => {
      const value = bankCode;
      if (depositManage === 'NONSELF') {
        if (!value) {
          setBankCodeError('必須項目です。');
          return 1;
        }
        if (!/^[0-9\b]+$/.test(value)) {
          setBankCodeError('データが正しくありません。');
          return 1;
        }
        if (value.length !== 4) {
          setBankCodeError('データが正しくありません。');
          return 1;
        }
        if (!getBankName(value)) {
          return 1;
        }
      }
      setBankCodeError('');
      return 0;
    };

    const validBankBranchCode = () => {
      const value = bankBranchCode;
      if (depositManage === 'NONSELF') {
        if (!value) {
          setBankBranchCodeError('必須項目です。');
          return 1;
        }
        if (!/^[0-9\b]+$/.test(value)) {
          setBankBranchCodeError('データが正しくありません。');
          return 1;
        }
        if (value.length !== 3) {
          setBankBranchCodeError('データが正しくありません。');
          return 1;
        }
        if (!getBankBranchName(value)) {
          return 1;
        }
      }
      setBankBranchCodeError('');
      return 0;
    };
    const valid = emailData => {
      let errorCount =
        validGroupName() +
        validZipCode() +
        validCityId() +
        validZipCodeSubmit() +
        validAddress() +
        validGroupContactName() +
        validDepartment() +
        validDirectPhone() +
        validPhone() +
        validEmail() +
        validWebsite() +
        validBankAccountNumber() +
        validBankAccountHolder() +
        validBankCode() +
        validBankBranchCode() +
        validRegistrationId();
      if (emailData) errorCount += validEmailCount(emailData);
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const convertImages = () => {
      const imageArray = {
        0: {
          image: image1,
          imagePath: previewImage1
        },
        1: {
          image: image2,
          imagePath: previewImage2
        },
        2: {
          image: image3,
          imagePath: previewImage3
        },
        3: {
          image: image4,
          imagePath: previewImage4
        },
        4: {
          image: image5,
          imagePath: previewImage5
        }
      };
      return imageArray;
    };

    const convertGroupTypeStr = mode => {
      if (mode === 'CHAIN_SHOP') {
        setGroupTypeStr('チェーン店');
      } else if (mode === 'COMMERCIAL_COMPLEX') {
        setGroupTypeStr('商業施設');
      } else if (mode === 'CAMPAIGN') {
        setGroupTypeStr('キャンペーン');
      } else if (mode === 'GOCHI_KID') {
        setGroupTypeStr('こどもごちめし特別資金グループ');
      } else {
        setGroupTypeStr('その他/仮想店舗');
      }
    };
    const convertDepositManageStr = mode => {
      if (mode === 'NONSELF') {
        setDepositManageStr('銀行口座を登録する');
      } else {
        setDepositManageStr('グループでは入金管理を登録しない');
      }
    };
    const convertBankAccountTypeStr = mode => {
      if (mode === 'SAVINGS') {
        setBankAccountTypeStr('普通預金');
      } else {
        setBankAccountTypeStr('当座預金');
      }
    };

    const cancelAction = () => updateOpenEditModal(false);
    const confirmAction = async () => {
      const emailData = await actions
        .countGroupEmail(email)
        .then(data => checkSession(data));
      if (!valid(emailData)) {
        alert('登録情報を正しく入力してください。');
      } else {
        setCityNameData(cityId);
        updateOpenEditConfirm(true);
        setMultiLangData(getCurrentData());
      }
    };
    const backAction = () => updateOpenEditConfirm(false);
    const editAction = async () => {
      updateLoading(true);
      updateOpenEditProgress(true);
      const images = convertImages();
      const editedGroup = await actions
        .editGroup(groupId, multiLangData)
        .then(data => checkSession(data));
      const imagePaths = await Promise.all(
        Object.keys(images).map(async i => {
          if (images[i].image !== null) {
            let { image } = images[i];
            if (image.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
              const { resizeImageFile } = await resizeImage(image);
              image = resizeImageFile;
            }
            const imagePath = await uploadFile(
              'group',
              groupId,
              image,
              'public'
            );
            return imagePath;
          }
          if (images[i].imagePath !== null) {
            return images[i].imagePath;
          }
          return null;
        })
      );
      const addImages = imagePaths
        .filter(i => i !== null)
        .map((i, index) => {
          return { image: i, viewOrder: index };
        });
      if (Object.keys(addImages).length !== 0) {
        await actions
          .addGroupImage(groupId, {
            images: addImages
          })
          .then(data => checkSession(data));
      }
      if (editedGroup.type === 'EDIT_GROUP_SUCCESS') {
        updateIsEditSuccess(true);
        actions.getGroupDetail(groupId).then(data => {
          actions.getAccounts({ cognitoUserId: '' });
          checkSession(data);
          setDisplayGroupName(data.payload.groupName);
        });
        setResultMessage('編集が完了しました。');
        updateLoading(false);
      } else {
        updateIsEditSuccess(false);
        setResultMessage('編集に失敗しました。');
        updateLoading(false);
      }
    };

    const progressOkAction = () => {
      if (isEditSuccess) {
        updateOpenEditModal(false);
        updateOpenEditConfirm(false);
        updateOpenEditProgress(false);
        onEditSuccess();
      } else {
        updateOpenEditProgress(false);
      }
    };
    const getCitiesOptions = () => {
      const citiesOptions = [];
      const tmpObj = { label: '', value: '0' };
      if (!prefectureCode || prefectureCode === 0) {
        cities.forEach(item => {
          citiesOptions.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      } else {
        cities
          .filter(
            item =>
              item.prefCode && Number(item.prefCode) === Number(prefectureCode)
          )
          .forEach(item => {
            citiesOptions.push({
              label: item.cityName,
              value: String(item.cityId)
            });
          });
      }
      return { ...citiesOptions, tmpObj };
    };

    const handleChangeCity = (e, v) => {
      setCity(v.label);
      setCityId(e);
    };

    const handleChangeBankCode = value => {
      setBankCode(value);
      setBankName('');
      setBankBranchCode('');
      setBankBranchName('');
    };

    return (
      <div className={classes.root}>
        <div>
          <Typography className={classes.titleDetail} variant="h6">
            グループ情報 編集
          </Typography>
        </div>
        <div className={classes.selectContainer}>
          <Select
            className={`${classes.textField} ${classes.select}`}
            value={isLanguage}
            onChange={e => {
              if (isLanguage === e.target.value) {
                return;
              }
              if (
                valid() ||
                (isLanguage !== languageType.ORIGIN && translateType === 0)
              ) {
                setLanguage(e.target.value);
              } else {
                alert('登録情報を正しく入力してください。');
              }
            }}
          >
            {languages.map(lang => (
              <MenuItem key={lang.value} value={lang.value}>
                {lang.label}
              </MenuItem>
            ))}
          </Select>
        </div>
        {isLanguage !== languageType.ORIGIN && (
          <ListItem className={classes.itemForm}>
            <Typography component="div" className={classes.formInput}>
              <RadioGroup
                value={translateType}
                onChange={e => {
                  setTranslateType(parseInt(e.target.value, 10));
                }}
              >
                <FormControlLabel
                  value={0}
                  control={<Radio color="primary" />}
                  label="GG翻訳を選択"
                />
                <FormControlLabel
                  value={1}
                  control={<Radio color="primary" />}
                  label="自分で文章入力"
                />
              </RadioGroup>
            </Typography>
          </ListItem>
        )}
        <Tabs
          value={tab}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          className={classes.tabpanelHeader}
        >
          <Tab
            label="基本情報（必須）"
            className={classNames(
              classes.btnTabpanel,
              tab === 0 && classes.tabSelected
            )}
          />
          <Tab
            label="その他（任意）"
            className={classNames(
              classes.btnTabpanel,
              tab === 1 && classes.tabSelected
            )}
          />
          {!groupDisplayLimit && !isFukuoka && (
            <Tab
              label="高度な設定（任意）"
              className={classNames(
                classes.btnTabpanel,
                tab === 2 && classes.tabSelected
              )}
            />
          )}
        </Tabs>
        <TabPanelDetail value={tab} index={0}>
          <div className={classes.panelDetail}>
            <Table className={classes.editTable}>
              <TableRow>
                <TableCell className={classes.labelCell}>
                  <RequiredButton />
                </TableCell>
                <TableCell className={classes.tableCell90}>
                  <TextField
                    required
                    fullWidth
                    label="運営会社"
                    value={groupName}
                    className={classes.textField}
                    onChange={e => {
                      setGroupName(e.target.value);
                    }}
                    onBlur={validGroupName}
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      maxLength: 250
                    }}
                    disabled={
                      isLanguage !== languageType.ORIGIN && translateType === 0
                    }
                  />
                  {(isLanguage === languageType.ORIGIN ||
                    translateType === 1) && (
                    <ValidationText message={errors.groupNameError} />
                  )}
                </TableCell>
                <TableCell />
              </TableRow>
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell
                    className={`${classes.tableCellBorderNone} ${
                      classes.labelCell
                    }`}
                  >
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone}>
                    <TextField
                      required
                      fullWidth
                      label="郵便番号"
                      defaultValue={editInput.zipCode}
                      className={classes.textField}
                      onChange={e => {
                        setZipCode(e.target.value);
                      }}
                      onBlur={validZipCode}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                    <br />
                    <Typography variant="h7">
                      ハイフンなしで記載ください
                    </Typography>
                    <ValidationText message={errors.zipCodeError} />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone} />
                  <TableCell className={classes.tableCellBorderNone}>
                    <TextField
                      required
                      autoFocus
                      select
                      fullWidth
                      label="都道府県"
                      className={classes.textField}
                      value={prefectureCode}
                      onChange={e => {
                        setPrefectureCode(e.target.value);
                        setCityId(Number(0));
                        setCity('');
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                    >
                      {prefectures.map(item => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone} />
                  <TableCell className={classes.tableCellBorderNone}>
                    {prefectureCode > 0 && (
                      <ReactSelectMaterialUi
                        required
                        label="市区町村*"
                        fullWidth
                        className={classes.textField}
                        defaultValue={String(checkCityName())}
                        value={String(cityId)}
                        options={getCitiesOptions()}
                        onChange={handleChangeCity}
                        SelectProps={{
                          isClearable: true,
                          msgNoOptionsMatchFilter:
                            '名前が部分一致する店舗がありません'
                        }}
                        onBlur={validCityId}
                      />
                    )}
                    {(!prefectureCode || prefectureCode <= 0) && (
                      <ReactSelectMaterialUi
                        disabled
                        required
                        fullWidth
                        label="市区町村*"
                        className={classes.textField}
                        defaultValue={String(checkCityName())}
                        value={String(cityId)}
                        options={getCitiesOptions()}
                        onChange={handleChangeCity}
                        SelectProps={{
                          isClearable: true,
                          msgNoOptionsMatchFilter:
                            '名前が部分一致する店舗がありません'
                        }}
                        onBlur={validCityId}
                      />
                    )}
                    {editInput.city && !cityId && checkCityName() <= 0 && (
                      <Typography variant="h7">
                        市区町村はまだ正規化されません。再度設定してください。
                      </Typography>
                    )}
                    <ValidationText message={errors.cityIdError} />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone} />
                  <TableCell className={classes.tableCellBorderNone}>
                    <TextField
                      required
                      fullWidth
                      label="町域・番地"
                      value={address}
                      className={classes.textField}
                      onChange={e => {
                        setAddress(e.target.value);
                      }}
                      onBlur={validAddress}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        maxLength: 250
                      }}
                      disabled={
                        isLanguage !== languageType.ORIGIN &&
                        translateType === 0
                      }
                    />
                    {(isLanguage === languageType.ORIGIN ||
                      translateType === 1) && (
                      <ValidationText message={errors.addressError} />
                    )}
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell />
                  <TableCell>
                    <TextField
                      fullWidth
                      label="建物名"
                      value={building}
                      className={classes.textField}
                      onChange={e => {
                        setBuilding(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        maxLength: 250
                      }}
                      disabled={
                        isLanguage !== languageType.ORIGIN &&
                        translateType === 0
                      }
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.labelCell}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell>
                    <TextField
                      required
                      fullWidth
                      label={isFukuoka ? '代表電話番号' : '電話番号'}
                      defaultValue={editInput.phone}
                      className={classes.textField}
                      onChange={e => {
                        setPhone(e.target.value);
                      }}
                      onBlur={validPhone}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                    <br />
                    <Typography variant="h7">
                      ハイフンなしで記載ください
                    </Typography>
                    <ValidationText message={errors.phoneError} />
                  </TableCell>
                  <TableCell />
                </TableRow>
              )}
              {!isFukuoka && (
                <TableRow>
                  <TableCell
                    className={`${classes.tableCellBorderNone} ${
                      classes.labelCell
                    }`}
                  >
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone}>
                    <div className={classes.descriptionText}>
                      {`(店舗オーナーさまへの依頼）
店舗オーナーさまが登録された店舗の現場に連絡しても、 「ごちめし」のことを全く知らないという事例が発生してきています。 店舗登録時には現場の責任者に了解を取った後に登録ください`}
                    </div>
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                {isFukuoka ? (
                  <TableCell
                    className={`${classes.tableCellBorderNone} ${
                      classes.labelCell
                    }`}
                  >
                    <RequiredButton />
                  </TableCell>
                ) : (
                  <TableCell className={classes.tableCellBorderNone} />
                )}
                <TableCell className={classes.tableCellBorderNone}>
                  <TextField
                    required
                    label="ご担当者名"
                    defaultValue={editInput.groupContactName}
                    fullWidth
                    className={classes.textField}
                    onChange={e => {
                      setGroupContactName(e.target.value);
                    }}
                    onBlur={validGroupContactName}
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      maxLength: 250
                    }}
                    value={groupContactName}
                    disabled={
                      isLanguage !== languageType.ORIGIN && translateType === 0
                    }
                  />
                  {(isLanguage === languageType.ORIGIN ||
                    translateType === 1) && (
                    <ValidationText message={errors.groupContactNameError} />
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellBorderNone} />
                <TableCell className={classes.tableCellBorderNone}>
                  <TextField
                    required
                    label="所属部署"
                    defaultValue={editInput.department}
                    fullWidth
                    className={classes.textField}
                    onChange={e => {
                      setDepartment(e.target.value);
                    }}
                    onBlur={validDepartment}
                    inputProps={{
                      maxLength: 250
                    }}
                    value={department}
                    disabled={
                      isLanguage !== languageType.ORIGIN && translateType === 0
                    }
                  />
                  {(isLanguage === languageType.ORIGIN ||
                    translateType === 1) && (
                    <ValidationText message={errors.departmentError} />
                  )}
                </TableCell>
              </TableRow>
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.tableCellBorderNone} />
                  <TableCell className={classes.tableCellBorderNone}>
                    <TextField
                      required
                      label="電話番号（直通等）"
                      defaultValue={editInput.directPhone}
                      fullWidth
                      className={classes.textField}
                      onChange={e => {
                        setDirectPhone(e.target.value);
                      }}
                      onBlur={validDirectPhone}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                    <ValidationText message={errors.directPhoneError} />
                  </TableCell>
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.noPaddingTop} />
                  <TableCell className={classes.noPaddingTop}>
                    <div className={classes.descriptionText}>
                      ハイフンなしで記載ください
                    </div>
                  </TableCell>
                </TableRow>
              )}
              {!isFukuoka &&
                !groupDisplayLimit &&
                isLanguage === languageType.ORIGIN && (
                  <>
                    <TableRow>
                      <TableCell
                        className={`${classes.tableCellBorderNone} ${
                          classes.labelCell
                        }`}
                      >
                        <RequiredButton />
                      </TableCell>
                      <TableCell className={classes.tableCellBorderNone}>
                        <Typography>インボイス制度 適格事業者登録*</Typography>
                        <RadioGroup
                          row
                          value={haveRegistrationId}
                          onChange={e => {
                            setHaveRegistrationId(parseInt(e.target.value, 10));
                          }}
                        >
                          <FormControlLabel
                            value={0}
                            control={<Radio color="primary" />}
                            label="未登録"
                          />
                          <FormControlLabel
                            value={1}
                            control={<Radio color="primary" />}
                            label="登録済み"
                          />
                        </RadioGroup>
                      </TableCell>
                    </TableRow>
                    {haveRegistrationId === 1 && (
                      <TableRow>
                        <TableCell
                          className={`${classes.tableCellBorderNone} ${
                            classes.labelCell
                          }`}
                        />
                        <TableCell className={classes.tableCellBorderNone}>
                          <TextField
                            required
                            label="適格事業者登録番号"
                            className={classes.textField}
                            onChange={e => {
                              if (e.target.value[0] === 'T') {
                                setRegistrationId(e.target.value);
                              } else if (!e.target.value) {
                                setRegistrationId('T');
                              }
                            }}
                            value={registrationId}
                            onBlur={validRegistrationId}
                            InputLabelProps={{
                              shrink: true
                            }}
                            fullWidth
                          />
                          <ValidationText
                            message={errors.registrationIdError}
                          />
                          <Typography variant="h7">
                            Tの後に続く13桁の番号を入力してください。
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </>
                )}
              {isLanguage === languageType.ORIGIN && !isFukuoka && (
                <TableRow>
                  <TableCell
                    className={`${classes.tableCellBorderNone} ${
                      classes.labelCell
                    }`}
                  >
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone}>
                    <FormLabel
                      component="legend"
                      className={classes.fontSize12}
                    >
                      グループ種別*
                    </FormLabel>
                    <RadioGroup
                      value={groupType}
                      onChange={e => {
                        setGroupType(e.target.value);
                        convertGroupTypeStr(e.target.value);
                      }}
                    >
                      <FormControlLabel
                        value="CHAIN_SHOP"
                        disabled
                        control={<Radio color="primary" />}
                        label="チェーン店"
                      />
                      <div className={classes.descriptionText}>
                        {`[チェーン店]
同一（あるいは複数）ブランドの直営・フランチャイズ展開を実施している場合に選択ください。`}
                      </div>
                      <FormControlLabel
                        value="COMMERCIAL_COMPLEX"
                        disabled
                        control={<Radio color="primary" />}
                        label="商業施設"
                      />
                      <div className={classes.descriptionText}>
                        {`[商業施設]
経営会社が異なる複数ブランドを束ねた施設を運営している場合に選択ください。`}
                      </div>
                      <FormControlLabel
                        value="CAMPAIGN"
                        disabled
                        control={<Radio color="primary" />}
                        label="キャンペーン"
                      />
                      <div className={classes.descriptionText}>
                        {`[キャンペーン]
自治体案件や、期間限定キャンペーンなどに該当する場合に選択してください。`}
                      </div>
                      <FormControlLabel
                        value="OTHERS"
                        disabled
                        control={<Radio color="primary" />}
                        label="その他/仮想店舗"
                      />
                      <div className={classes.descriptionText}>
                        {`[その他/仮想店舗]
子ども食堂、災害時支援など、上記と異なる用途の場合に選択ください。`}
                      </div>
                      <FormControlLabel
                        value="GOCHI_KID"
                        disabled
                        control={<Radio color="primary" />}
                        label="こどもごちめし特別資金グループ"
                      />
                      <div className={classes.descriptionText}>
                        {`[こどもごちめし特別資金グループ]
こどもごちめし特別資金グループに該当する場合に選択してください。`}
                      </div>
                    </RadioGroup>
                  </TableCell>
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell
                    className={`${classes.tableCellBorderNone} ${
                      classes.labelCell
                    }`}
                  >
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone}>
                    <TextField
                      required
                      fullWidth
                      label="メールアドレス"
                      defaultValue={editInput.email}
                      className={classes.textField}
                      InputProps={{
                        readOnly: true,
                        shrink: true
                      }}
                      onChange={e => {
                        setEmail(e.target.value);
                      }}
                      onBlur={validEmail}
                    />
                    <ValidationText message={errors.emailError} />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell />
                  <TableCell className={classes.descriptionText}>
                    {isFukuoka
                      ? `メールアドレスは、本事業に関する連絡や管理システムのログインIDとして利用します。 メールアドレスを変更する場合は、設定 > メールアドレス変更 より行ってください。`
                      : `メールアドレスは、ごちめしの各種ご連絡、および、管理システムのIDとしても利用いたします。 メールアドレスの変更を行いたい場合にはサイドナビゲーションの設定  > メールアドレス変更 より行ってください。`}
                  </TableCell>
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && !groupDisplayLimit && (
                <TableRow>
                  <TableCell
                    className={`${classes.tableCellBorderNone} ${
                      classes.labelCell
                    }`}
                  >
                    <RequiredButton />
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone}>
                    <FormLabel
                      component="legend"
                      className={classes.fontSize12}
                    >
                      {isFukuoka ? 'グループ口座登録*' : '入金管理*'}
                    </FormLabel>
                    <RadioGroup
                      value={depositManage}
                      onChange={e => {
                        setDepositManage(e.target.value);
                        convertDepositManageStr(e.target.value);
                      }}
                    >
                      <div>
                        <FormControlLabel
                          value="NOT_MANAGE"
                          control={<Radio color="primary" />}
                          label={
                            isFukuoka
                              ? 'グループ口座を登録しない'
                              : 'グループでは入金管理を登録しない'
                          }
                          disabled={
                            !stripeUseSwitchable ||
                            editInput.groupAccountStatus.stripeAccount
                          }
                        />
                        <Typography className={classes.descriptionText}>
                          {isFukuoka
                            ? '教室ごとに別々の振込先を希望される場合は、こちらを選択してください。なお、各教室のログインIDで管理システムにログインし、それぞれ口座登録をする必要があります。'
                            : 'グループの各店舗別に、入金する銀行口座を登録して頂きます。'}
                        </Typography>
                      </div>
                      <div>
                        <FormControlLabel
                          value="NONSELF"
                          control={<Radio color="primary" />}
                          label={
                            isFukuoka
                              ? 'グループ口座を登録する'
                              : '銀行口座を登録する'
                          }
                          disabled={
                            !stripeUseSwitchable ||
                            editInput.groupAccountStatus.stripeAccount
                          }
                        />
                        <Typography className={classes.descriptionText}>
                          {isFukuoka ? (
                            '全教室同じ振込先を希望される場合は、こちらを選択してください。下記の口座に振り込まれます。なお、口座情報はグループ管理者のみ閲覧・変更ができます。'
                          ) : (
                            <>
                              グループの全店舗の入金が同一の口座に振り込まれます。
                              <br />
                              また各店舗の登録情報に口座情報は掲載されません。
                              <br />
                              ※(注意)『自社で入金管理する』を選択している店舗をグループに紐付けると、店舗のstripe連携が外れます。
                            </>
                          )}
                        </Typography>
                      </div>
                    </RadioGroup>
                  </TableCell>
                </TableRow>
              )}
              {depositManage === 'NONSELF' &&
                !groupDisplayLimit &&
                isLanguage === languageType.ORIGIN && (
                  <>
                    <TableRow>
                      <TableCell className={classes.tableCellBorderNone} />
                      <TableCell className={classes.tableCellBorderNone}>
                        <TextField
                          required
                          label="銀行コード"
                          defaultValue={editInput.bankAccount.bankCode}
                          placeholder="0000"
                          fullWidth
                          className={classes.textField}
                          onChange={e => {
                            handleChangeBankCode(e.target.value);
                          }}
                          onBlur={validBankCode}
                          disabled={!stripeUseSwitchable}
                          InputLabelProps={{
                            shrink: true
                          }}
                          inputProps={{
                            maxLength: 4,
                            inputMode: 'numeric'
                          }}
                        />
                        <Typography className={classes.descriptionText}>
                          ※
                          <Link
                            href="https://zengin.ajtw.net/"
                            target="_blank"
                            className={classes.link}
                          >
                            検索サイト
                          </Link>
                        </Typography>
                        <Typography className={classes.descriptionText}>
                          半角数字・4桁（3桁以下の方は、先頭に0をつけて4桁にしてください）
                        </Typography>
                        <ValidationText message={errors.bankCodeError} />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellBorderNone} />
                      <TableCell className={classes.tableCellBorderNone}>
                        <TextField
                          label="銀行名"
                          defaultValue={editInput.bankAccount.bankName}
                          fullWidth
                          className={[classes.textField, classes.disableInput]}
                          disabled
                          InputLabelProps={{
                            shrink: true
                          }}
                          value={bankName}
                        />
                      </TableCell>
                    </TableRow>
                  </>
                )}
              {depositManage === 'NONSELF' &&
                !groupDisplayLimit &&
                isLanguage === languageType.ORIGIN && (
                  <>
                    <TableRow>
                      <TableCell className={classes.tableCellBorderNone} />
                      <TableCell className={classes.tableCellBorderNone}>
                        <TextField
                          required
                          label="支店コード"
                          defaultValue={editInput.bankAccount.bankBranchCode}
                          placeholder="000"
                          fullWidth
                          className={classes.textField}
                          onChange={e => {
                            setBankBranchCode(e.target.value);
                            setBankBranchName('');
                          }}
                          onBlur={validBankBranchCode}
                          disabled={!stripeUseSwitchable}
                          InputLabelProps={{
                            shrink: true
                          }}
                          inputProps={{
                            maxLength: 3,
                            inputMode: 'numeric'
                          }}
                          value={bankBranchCode}
                        />
                        <Typography className={classes.descriptionText}>
                          ※
                          <Link
                            href="https://zengin.ajtw.net/"
                            target="_blank"
                            className={classes.link}
                          >
                            検索サイト
                          </Link>
                        </Typography>
                        <Typography className={classes.descriptionText}>
                          半角数字・3桁（2桁以下の方は、先頭に0をつけて3桁にしてください）
                        </Typography>
                        <ValidationText message={errors.bankBranchCodeError} />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableCellBorderNone} />
                      <TableCell className={classes.tableCellBorderNone}>
                        <TextField
                          label="支店名"
                          defaultValue={editInput.bankAccount.bankBranchName}
                          fullWidth
                          className={[classes.textField, classes.disableInput]}
                          disabled
                          InputLabelProps={{
                            shrink: true
                          }}
                          value={bankBranchName}
                        />
                      </TableCell>
                    </TableRow>
                  </>
                )}
              {depositManage === 'NONSELF' &&
                !groupDisplayLimit &&
                isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell className={classes.tableCellBorderNone}>
                      <Typography className={classes.description}>
                        口座種別
                      </Typography>
                      <RadioGroup
                        row
                        value={bankAccountType}
                        onChange={e => {
                          setBankAccountType(e.target.value);
                          convertBankAccountTypeStr(e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value="SAVINGS"
                          control={<Radio color="primary" />}
                          label="普通預金"
                          disabled={!stripeUseSwitchable}
                        />
                        <FormControlLabel
                          value="CHECKING"
                          control={<Radio color="primary" />}
                          label="当座預金"
                          disabled={!stripeUseSwitchable}
                        />
                      </RadioGroup>
                    </TableCell>
                  </TableRow>
                )}
              {depositManage === 'NONSELF' &&
                !groupDisplayLimit &&
                isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell className={classes.tableCellBorderNone}>
                      <TextField
                        required
                        label="口座番号"
                        defaultValue={editInput.bankAccount.bankAccountNumber}
                        placeholder="1234567"
                        fullWidth
                        className={classes.textField}
                        onChange={e => {
                          setBankAccountNumber(e.target.value);
                        }}
                        onBlur={validBankAccountNumber}
                        disabled={!stripeUseSwitchable}
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                      <ValidationText message={errors.bankAccountNumberError} />
                    </TableCell>
                  </TableRow>
                )}
              {depositManage === 'NONSELF' &&
                !groupDisplayLimit &&
                isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell
                      className={`${classes.tableCellBorderNone} ${
                        classes.descriptionText
                      }`}
                    >
                      半角数字・7桁（6桁以下の方は先頭に0をつけて7桁にしてください）
                    </TableCell>
                  </TableRow>
                )}
              {depositManage === 'NONSELF' &&
                !groupDisplayLimit &&
                isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell className={classes.tableCellBorderNone}>
                      <TextField
                        required
                        label="口座名義"
                        defaultValue={editInput.bankAccount.bankAccountHolder}
                        placeholder="ヤマダ　タロウ"
                        fullWidth
                        className={classes.textField}
                        onChange={e => {
                          setBankAccountHolder(e.target.value);
                        }}
                        onBlur={validBankAccountHolder}
                        disabled={!stripeUseSwitchable}
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                      <ValidationText message={errors.bankAccountHolderError} />
                    </TableCell>
                  </TableRow>
                )}
              {depositManage === 'NONSELF' &&
                !groupDisplayLimit &&
                isLanguage === languageType.ORIGIN && (
                  <TableRow>
                    <TableCell className={classes.tableCellBorderNone} />
                    <TableCell
                      className={`${classes.tableCellBorderNone} ${
                        classes.descriptionText
                      }`}
                    >
                      {isFukuoka
                        ? 'カタカナでご記入ください'
                        : '必ず漢字/ひらがな以外でご記入ください。'}
                    </TableCell>
                  </TableRow>
                )}
            </Table>
          </div>
        </TabPanelDetail>
        <TabPanelDetail value={tab} index={1}>
          <div className={classes.panelDetail}>
            <Table className={classes.editTable}>
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.labelCell}>
                    <AnyButton />
                  </TableCell>
                  <TableCell>
                    <TextField
                      label="FAX"
                      fullWidth
                      defaultValue={editInput.fax}
                      className={classes.textField}
                      onChange={e => {
                        setFax(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.labelCell}>
                    <AnyButton />
                  </TableCell>
                  <TableCell>
                    <TextField
                      multiline
                      rows="3"
                      label="担当者メールアドレス"
                      fullWidth
                      defaultValue={editInput.groupContactEmail}
                      className={classes.textField}
                      onChange={e => {
                        setGroupContactEmail(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        maxLength: 1000
                      }}
                      value={groupContactEmail}
                    />
                    <br />
                    <br />
                    <Typography variant="h7">
                      {isFukuoka ? (
                        <>
                          担当者様が複数いる場合、半角カンマで区切ってください。例）xxx@gmail.com,yyy@gmail.com,zzz@gmail.com
                        </>
                      ) : (
                        <>
                          担当者様が複数いる場合、こちらに情報を記載ください。例）xxx@gmail.com,yyy@gmail.com,zzz@gmail.com
                        </>
                      )}
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && !isFukuoka && (
                <TableRow>
                  <TableCell className={classes.labelCell}>
                    <AnyButton />
                  </TableCell>
                  <TableCell className={classes.colRight}>
                    <FormLabel className={classes.fontSize12}>画像</FormLabel>
                    <FileUpload
                      label="image1"
                      setFile={setImage1}
                      previewImage={previewImage1}
                      setPreviewImage={setPreviewImage1}
                    />
                    <FileUpload
                      label="image2"
                      setFile={setImage2}
                      previewImage={previewImage2}
                      setPreviewImage={setPreviewImage2}
                    />
                    <FileUpload
                      label="image3"
                      setFile={setImage3}
                      previewImage={previewImage3}
                      setPreviewImage={setPreviewImage3}
                    />
                    <FileUpload
                      label="image4"
                      setFile={setImage4}
                      previewImage={previewImage4}
                      setPreviewImage={setPreviewImage4}
                    />
                    <FileUpload
                      label="image5"
                      setFile={setImage5}
                      previewImage={previewImage5}
                      setPreviewImage={setPreviewImage5}
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
              )}
              {!isFukuoka && (
                <TableRow>
                  <TableCell className={classes.labelCell}>
                    <AnyButton />
                  </TableCell>
                  <TableCell>
                    <TextField
                      label="グループの概要"
                      fullWidth
                      defaultValue={editInput.description}
                      className={classes.textField}
                      onChange={e => {
                        setDescription(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        maxLength: 250
                      }}
                      value={description}
                      disabled={
                        isLanguage !== languageType.ORIGIN &&
                        translateType === 0
                      }
                    />
                  </TableCell>
                  <TableCell />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && !isFukuoka && (
                <TableRow>
                  <TableCell className={classes.labelCell}>
                    <AnyButton />
                  </TableCell>
                  <TableCell>
                    <TextField
                      label="WebページURL"
                      fullWidth
                      defaultValue={editInput.website}
                      className={classes.textField}
                      onChange={e => {
                        setWebsite(e.target.value);
                      }}
                      onBlur={validWebsite}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                    <ValidationText message={errors.websiteError} />
                  </TableCell>
                  <TableCell />
                </TableRow>
              )}
              {isLanguage === languageType.ORIGIN && (
                <TableRow>
                  <TableCell className={classes.labelCell}>
                    <AnyButton />
                  </TableCell>
                  <TableCell>
                    <TextField
                      multiline
                      rows="3"
                      label="グループ紐付け時のメッセージ"
                      fullWidth
                      defaultValue={editInput.linkingShopMessage}
                      className={classes.textField}
                      onChange={e => {
                        setLinkingShopMessage(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        maxLength: 1000
                      }}
                      value={linkingShopMessage}
                    />
                    <br />
                    <br />
                    <Typography variant="h7">
                      {isFukuoka ? (
                        <>
                          教室をグループに紐付けると、教室にお知らせメールが自動送信されます。メールに教室への連絡を追加したい場合は、入力してください。
                        </>
                      ) : (
                        <>
                          店舗をグループに紐づける時にメールが送信されます。対象店舗にグループ紐付け時にお伝えしたいメッセージを記載することができます。
                        </>
                      )}
                    </Typography>
                  </TableCell>
                  <TableCell className={classes.tableCellBorderNone} />
                </TableRow>
              )}
            </Table>
          </div>
        </TabPanelDetail>
        {!groupDisplayLimit && (
          <TabPanelDetail value={tab} index={2}>
            <div className={classes.panelDetail}>
              <Table className={classes.editTable}>
                <TableRow>
                  <TableCell className={classes.labelCell}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell>
                    <Typography color="textSecondary">
                      社食ごちめし金額指定チケット利用の有無
                    </Typography>
                    <RadioGroup
                      row
                      value={allowMenuPriceShashoku}
                      onChange={e => {
                        setAllowMenuPriceShashoku(parseInt(e.target.value, 0));
                      }}
                    >
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="利用する"
                      />
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="利用しない"
                      />
                    </RadioGroup>
                    <Typography
                      variant="h7"
                      className={classes.detailDescription}
                    >
                      GOCHIプラットフォーム提供サイト「社食ごちめし」にて、金額を指定してお食事ができる機能となります。GOCHIプラットフォームに登録していないメニューの決済も、金額を入力した決済ができるため、可能となります。
                      <br />
                      例）ご利用ユーザー様が550円と入力すると、550円の決済が可能となります。
                      <br />
                      ※デフォルト設定は「利用する」を推奨しております。
                      <br />
                      ※「利用しない」を設定される場合、メニュー登録の充実や定期更新などをお願いしております。
                    </Typography>
                  </TableCell>
                </TableRow>
                {/* <TableRow>
                  <TableCell className={classes.labelCell}>
                    <RequiredButton />
                  </TableCell>
                  <TableCell>
                    <Typography className={classes.description}>
                      社食ごちめし現金授受の有無
                    </Typography>
                    <RadioGroup
                      row
                      value={cashAllowed}
                      onChange={e => {
                        const allowed = parseInt(e.target.value, 10);
                        setCashAllowed(allowed);
                      }}
                    >
                      <FormControlLabel
                        value={0}
                        control={<Radio color="primary" />}
                        label="受け付けない"
                        disabled
                      />
                      <FormControlLabel
                        value={1}
                        control={<Radio color="primary" />}
                        label="受け付ける"
                        disabled
                      />
                    </RadioGroup>
                    <Typography
                      variant="h7"
                      className={classes.detailDescription}
                    >
                      GOCHIプラットフォーム提供の「社食ごちめし」サイトにて、企業負担予算を超過してお支払いが発生する際に、差額を現金でお支払いできる機能です。
                      <br />
                      例）1,000円のメニューに対して、社食費用が500円の場合、差額の500円を現金で支払う
                      <br />
                      本項目につきましては、キャッシュレス決済を推進させていただき、現金授受を受け付けない設定とさせていただきます。
                    </Typography>
                  </TableCell>
                </TableRow> */}
              </Table>
            </div>
          </TabPanelDetail>
        )}
        <div className={classes.buttonContainer}>
          <CancelButton onClickAction={cancelAction} color="primary" />
          <ConfirmButton onClickAction={confirmAction} />
        </div>
        <Modal open={openEditConfirm} className={classes.modal}>
          <GroupEditConfirmGroup
            backAction={backAction}
            editAction={editAction}
            detail={multiLangData}
            otherData={otherData}
            openEditProgress={openEditProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
            currentLanguage={isLanguage}
            setIsLanguage={setIsLanguage}
            isFukuoka={isFukuoka}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
